import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IconButtonComponent } from '../icon-button/icon-button.component';

@Component({
    selector: 'lib-back-button',
    templateUrl: './back-button.component.html',
    styleUrls: ['./back-button.component.scss'],
    standalone: true,
    imports: [CommonModule, IconButtonComponent]
})
export class BackButtonComponent {
    /* eslint-disable */
    @Input() backButtonDefaultHref!: string;
    @Input() iconType: 'chevron' | 'arrow' = 'chevron';
    @Input() chevronIconPath!: string;
    @Input() arrowIconPath!: string;
    @Input() showBorder: boolean = false;
    @Input() color: string = 'var(--ion-color-dark)';
    @Input() rippleColor: string = 'var(--ion-color-dark)';
    @Input() backgroundColor: string = 'rgba(255, 255, 255, 0.6)';

    @Output() onClick = new EventEmitter();

    onButtonClick() {
        this.onClick.emit();
    }
}
